import moment from "moment";

export const fetchSmartLinks = async (apiUrl, token) => {
  const response = await fetch(apiUrl, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });

  if (!response.ok) throw new Error("Error al obtener links");

  const apiData = await response.json();
  const links = apiData.links || [];

    
    
  return links.map((link) => ({
    
    id: link.id || "N/A",
    url: link.url ?  process.env.REACT_APP_API_URL_PROD +`/Peiix/${link.url}` : "N/A",
    price: link.price,
    uses: link.uses,
    status: link.status || "inactive",
    product_name: link.product_name,

    
    name: link.customer_name || "N/A",
    address: link.address || "N/A",
    phone: link.phone || "N/A",
    email: link.email || "N/A",
    
    launch_time: link.launch_time
      ? moment(link.launch_time).format("YYYY/MM/DD HH:mm")
      : "Fecha no disponible",
  }));
};